import cookiesService from "@/services/cookiesService";
import axios from "axios";
import { API_URL, LOCALSTORAGEFIELDS, SYSTEMS } from "@/constants";
import { handleError } from "./helpers";
import { handleApiError } from "./errorHandler";
import { getSystemCode } from "..";

const cookiesServiceInstance = cookiesService.getService();
export let source;

function makeKey(config) {
  const { method, url, params, data } = config;
  return [
    method,
    url,
    params ? JSON.stringify(params) : "",
    data ? (typeof data === "string" ? data : JSON.stringify(data)) : "",
  ].join("|");
}
const inflight = new Map();

const instance = (authorization = true, url = null, paramsProps = {}) => {
  let params = { throwError: false, cancelPrevious: false, showToast: true };
  if (paramsProps) params = { ...params, ...paramsProps };

  const CancelToken = axios.CancelToken;
  source = CancelToken.source();

  const activeSystem = getSystemCode();
  const activeApiUrl = activeSystem ? SYSTEMS[activeSystem].API_URL : null;

  const axiosInstance = axios.create({
    baseURL: url || activeApiUrl || API_URL,
    cancelToken: paramsProps.cancelToken || source.token,
  });

  if (authorization) {
    axiosInstance.interceptors.request.use(
      (config) => {
        const jwtToken = cookiesServiceInstance.getAccessToken();
        if (!!jwtToken) config.headers.Authorization = `Bearer ${jwtToken}`;

        if (params.cancelPrevious) {
          const key = makeKey(config);

          const prev = inflight.get(key);
          if (prev) prev.abort();

          const ctl = new AbortController();
          config.signal = ctl.signal;
          inflight.set(key, ctl);
          config.__reqKey = key;
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }
  axiosInstance.interceptors.response.use(
    (response) => {
      if (response.config.__reqKey) inflight.delete(response.config.__reqKey);
      return response;
    },
    (error) => {
      if (axios.isCancel(error)) {
        return Promise.resolve();
      }
      if (parseInt(error.response?.status) === 401) {
        return handleError(error);
      }

      return handleApiError(error, {
        showToast: params?.showToast,
        throwError: params?.throwError,
      });
    }
  );
  return axiosInstance;
};

export default instance;
